<template>
  <rest-list-page :page-title="pageTitle" :fetch-endpoint="fetchEndpoint">
    <template slot="actions" v-if="!readonly">
      <router-link :to="createTextSnippetRoute">
        <el-button type="primary" icon="el-icon-plus">
          {{ $t('Snippets_List_CreateText') }}
        </el-button>
      </router-link>

      <router-link :to="createHTMLSnippetRoute">
        <el-button type="primary" icon="el-icon-plus">
          {{ $t('Snippets_List_CreateHTML') }}
        </el-button>
      </router-link>
    </template>

    <template slot="table">
      <rest-list-column-enum
        prop="type"
        :title="$t('Snippets_Type')"
        :enum="types"
      />
      <rest-list-column prop="name" :title="$t('Snippets_Name')" />
      <rest-list-column-actions v-if="readonly">
        <template slot-scope="scope">
          <rest-list-action-view :route="rowViewRoute(scope.row)" />
        </template>
      </rest-list-column-actions>
      <rest-list-column-actions v-else>
        <template slot-scope="scope">
          <rest-list-action-update :route="rowUpdateRoute(scope.row)" />
          <snippet-action-copy :route="rowCopyRoute(scope.row)" />
          <rest-list-action-delete :endpoint="rowDeleteEndpoint(scope.row)" />
        </template>
      </rest-list-column-actions>
    </template>
  </rest-list-page>
</template>

<script>
import RestApi from '@/core/services/RestApi'
import RestListPage from '@/common/components/rest/RestListPage'
import { projectEndpoint, projectRoute } from '@/core/helpers'
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestListColumnEnum from '@/common/components/rest/RestListColumnEnum'
import RestListColumnActions from '@/common/components/rest/RestListColumnActions'
import RestListActionView from '@/common/components/rest/RestListActionView'
import RestListActionUpdate from '@/common/components/rest/RestListActionUpdate'
import RestListActionDelete from '@/common/components/rest/RestListActionDelete'
import SnippetActionCopy from '@/modules/snippets/components/SnippetActionCopy'

export default {
  name: 'SnippetListPage',

  components: {
    SnippetActionCopy,
    RestListActionDelete,
    RestListActionUpdate,
    RestListActionView,
    RestListColumnActions,
    RestListColumnEnum,
    RestListColumn,
    RestListPage
  },

  data() {
    return {
      types: {}
    }
  },

  created() {
    RestApi.get(
      `projects/${this.$route.query.project_id}/snippets/options`
    ).then(({ data }) => {
      this.types = data
    })
  },

  computed: {
    pageTitle() {
      return this.$t(this.$route.meta.title)
    },

    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: 'snippets',
        params: {}
      })
    },

    createTextSnippetRoute() {
      return projectRoute({
        name: 'SnippetsCreate',
        query: { type: 1 }
      })
    },

    createHTMLSnippetRoute() {
      return projectRoute({
        name: 'SnippetsCreate',
        query: { type: 2 }
      })
    },

    readonly() {
      return !this.$can('ContentSnippet:FullAccess')
    }
  },

  methods: {
    rowViewRoute(row) {
      return projectRoute({
        name: 'SnippetsView',
        query: { id: row.id }
      })
    },

    rowUpdateRoute(row) {
      return projectRoute({
        name: 'SnippetsUpdate',
        query: { id: row.id }
      })
    },

    rowCopyRoute(row) {
      return projectRoute({
        name: 'SnippetsCopy',
        query: { id: row.id }
      })
    },

    rowDeleteEndpoint(row) {
      return projectEndpoint({
        method: 'delete',
        url: `snippets/${row.id}`
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/snippets/pages/SnippetListPage.vue